import React from 'react'
import { Heading, Text, Flex } from 'theme-ui'
export default function TextContent({ variantName, title, subtitle, text }) {
  return (
    <Flex variant={`${variantName}.textContent`} className='textContent'>
      {title && (
        <Heading as='h3' variant={`${variantName}.title`} className='title'>
          {title}
        </Heading>
      )}
      {subtitle && (
        <Heading
          as='h4'
          variant={`${variantName}.subtitle`}
          className='subtitle'>
          {subtitle}
        </Heading>
      )}
      {text && (
        <Text as='p' variant={`${variantName}.text`} className='text'>
          {text}
        </Text>
      )}
    </Flex>
  )
}
